export const ChunkyButton = ({ as: Tag = "button", bg = "#1e9bf0", edge = "#0b4fa3", color = "#fff", className = "", children, ...props }) => (
  <Tag
    {...props}
    className={`chunky-btn inline-flex min-h-[60px] items-center justify-center gap-3 rounded-full px-7 py-4 font-display text-lg font-semibold ${className}`}
    style={{ background: bg, color, "--btn-edge": edge }}
  >
    {children}
  </Tag>
);
